import Vue from 'vue/dist/vue.min.js';
import template from 'shared/meter-selector-frame.hbs';
import separatorTemplate from 'shared/meter-selector-frame-separator.hbs';
import questionTemplate from 'shared/meter-selector-frame-question.hbs';

Vue.component(
    "ms-frame",
    {
        props: {
            isLateralBar: { type: Boolean, default: false },
            transparent: { type: Boolean, default: true },
            closeButtonLabel: String,
            buttonLabel: String,
            cancelButtonLabel: String,
            disableButton: { type: Boolean, default: false },
            title: String,
            onCancel: Function,
            onClickButton: Function,
            hasParametersButton: { type: Boolean, default: false },
            contactButton: Object,
            message: String,
            notice: String,
        },
        data(){
            return {
                isOpen: false
            };
        },
        watch: {
            isOpen(v) {
                const nameClass = 'ms-frame_opened-lateral-bar';
                const layerNameClass = 'ms-frame_mobile-layer';
                const body = document.querySelector('body');

                if(v) {
                    body.classList.add(nameClass);
                    const layer = document.createElement('div');
                    layer.classList.add(layerNameClass);
                    body.appendChild(layer);
                } else {
                    const layer = document.querySelector(`.${layerNameClass}`);

                    layer && body.removeChild(layer);
                    body.classList.remove(nameClass);
                }
            }
        },
        computed:  {
            hasButton(){
                return Boolean(this.buttonLabel) && !Boolean(this.notice)
            },
            mobileButtonLabel() {
                return this.closeButtonLabel;
            },
            hasContactButton(){
                return Boolean(this.contactButton);
            },
            hasButtons(){
                return this.hasButton ||  this.hasContactButton;
            },
        },
        mounted() {
        },
        beforeUnmount() {
        },
        methods: {
            clickButton(){
                this.onClickButton && this.onClickButton();
            },
            open(){
                this.isOpen = !this.isOpen;
            },
            cancel(){
                this.onCancel && this.onCancel();
            }
        }, 
        template
    }
);

Vue.component(
    "ms-frame-separator",
    {
        props: {
            title: String,
        },
        template: separatorTemplate
    }
);

Vue.component(
    "ms-frame-question",
    {
        props: {
            index: Number,
            options: { type: Object, default: {} },
            value: Object,
            selectedUnit: String,
            onTriggerEvent: Function
        },
        data() {
            return {
                defaultValue: this.value,
            }
        },
        computed: {
            showTitle(){
                return this.options.button && this.index > 0 && this.options.question;
            },
            dropdownOptions(){
                return this.options.dropdown;
            },
            input(){
                const inputs = this.options.input;
                if (!inputs) {
                    return null;
                }

                const input = inputs[0];

                return { title: input.label, placeholder: input.placeholder };
            },
            defaultValues(){
                if (this.options.button) {
                    if (!this.defaultValue || !this.defaultValue.value) {
                        return [];
                    }

                    return typeof this.defaultValue.value === 'object' ? this.defaultValue.value : [this.defaultValue.value];
                }else{
                    if (!this.defaultValue || !this.defaultValue.inputValue) {
                        const def = {};

                        if (this.selectedUnit && this.options.options) {
                            def.switcher = { value: this.selectedUnit };
                        }

                        return def;
                    }

                    return this.defaultValue.inputValue;
                }
            },
            key(){
                return this.options.apiQuery.join();
            }
        },
        methods: {
            onChange(v){
                const { index, stepId: id, apiQuery, filterName:label = '' } = this.options;
                let input = null;

                if (this.options.button) {
                    const value = v.map(o => o.value);
                    const notice = (v.find(o => Boolean(o.selectedLabel)) || {}).selectedLabel || '';
                    const queryName = apiQuery && apiQuery[0];
                    const query = { [queryName]: value.length === 1 ? value[0] : value };
                    input = value.length === 0 ? null : { index, id, value, query, notice, label };
                } else {
                    const { input: inputValue, dropdown, switcher } = v;
                    const hasInput = Boolean(this.options.input);

                    input = {
                        value: inputValue,
                        inputValue: v,
                        option: switcher,
                        label
                    }; 

                    const queryName = apiQuery && apiQuery[0];
                    const query = { [queryName]: input.value };

                    if (apiQuery && apiQuery.length > 1 && (switcher || dropdown)) {
                        const unitName = apiQuery[apiQuery.length - 1];
                        query[unitName] = dropdown ? dropdown.value : switcher.value;
                    }

                    const isEmpty = input.value === '' || input.value === undefined || input.value === null;
                    input = !isEmpty ? { ...input, index, id, query } : null;
                }

                this.$emit('input', input);
            },
            onTriggerAnswerEvent(data) {
                this.onTriggerEvent({ ...data, questionIndex: this.index });
            }
        },
        template: questionTemplate
    }
);
